import { render, staticRenderFns } from "./refundDetailsList.vue?vue&type=template&id=dcf8005c&scoped=true&"
import script from "./refundDetailsList.vue?vue&type=script&lang=js&"
export * from "./refundDetailsList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=dcf8005c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf8005c",
  null
  
)

export default component.exports